module.exports = __webpack_public_path__ + "img/s2P20.0c29100a.png";